//对于axios进行二次封装
import axios from "axios";
//引入进度条
import nprogress from 'nprogress'

//引入进度条样式
import NProgress from 'nprogress'
import "nprogress/nprogress.css";
//start:进度条开始done：进度条结束

//1.利用axios对象的方法create，去创建一个axios实例
//2.request就是axios.只不过稍微配置一下
const requests = axios.create({
	//配置对象
	//基础路径，发请求的时候，路径当中会出现api
	//开发环境
//baseURL:"http://127.0.0.1:3007",
	//发布环境
//baseURL:"http://106.54.229.149:9001",
//开启ssl，启用https协议
baseURL:"https://zx-cargo.com:9001",
	//代表请求超时的时间5s
	timeout:5000,
	//全局请求头
	headers:{
		'Content-Type':'application/x-www-form-urlencoded;charset=utf-8',
		'PartialNProgress':'judge',
	},
})
requests.interceptors.request.use(config =>{
	//console.log(config)
	//判断进度条是否隐藏，查看是否有Partial请求，无则不执行NProgress.start()
	config.headers.Authorization = window.sessionStorage.getItem('token')
	console.log(config.headers.PartialNProgress)
	if(config.headers.PartialNProgress == undefined){
		return config
	}
	NProgress.start()
	return config
})
//在request 拦截器中，隐藏进度条NProgress.done();
requests.interceptors.response.use(config => {
	NProgress.done()
	return config
})

//对外暴露
export default requests;
